import { action, makeObservable, observable } from 'mobx';

import { ASSIGNMENT_MENU_STATUS } from './AssignmentManager';

/**
 * StudentAssignmentManager
 *
 * Contains student-only assignment configuration and state.
 *
 * Note: This is intentionally separate from AssignmentManager and StudentContentCardManager.
 *
 * Some student-only assignment logic may still live in other managers (such
 * as AssignmentManager and StudentContentCardManager), but when maintaining
 * or adding new student assignment specific logic, it would be ideal to favor
 * this manager when possible.
 */
export class StudentAssignmentManager {
  @observable alwaysExcludeStudentAssignmentCardAlignmentPills = true;

  @observable currentStudentAssignmentMenuStatus = null;

  @observable loadingStudentAssignmentMenu = false;

  // DEMO-3099: 'TODAY' status tab removed from the default. Note that
  // satellites can still opt in for the 'TODAY' tab by providing a custom
  // studentAssignmentMenuStatusOrderArray configuration (if needed).
  @observable studentAssignmentMenuStatusOrderArray = [
    ASSIGNMENT_MENU_STATUS.CURRENT,
    // ASSIGNMENT_MENU_STATUS.TODAY,
    ASSIGNMENT_MENU_STATUS.CLOSED,
    ASSIGNMENT_MENU_STATUS.GRADED
  ];

  @observable allowStudentAssignmentResourceTypeFilter = false;

  constructor() {
    makeObservable(this);
  }

  @action setAlwaysExcludeStudentAssignmentCardAlignmentPills = (toggle) => {
    this.alwaysExcludeStudentAssignmentCardAlignmentPills = toggle;
  }

  @action setCurrentStudentAssignmentMenuStatus = (currentStudentAssignmentMenuStatus) => {
    this.currentStudentAssignmentMenuStatus = currentStudentAssignmentMenuStatus;
  }

  @action setLoadingStudentAssignmentMenu = (toggle) => {
    this.loadingStudentAssignmentMenu = toggle;
  }

  @action setStudentAssignmentMenuStatusOrderArray = (studentAssignmentMenuStatusOrderArray) => {
    this.studentAssignmentMenuStatusOrderArray = studentAssignmentMenuStatusOrderArray;
  }

  @action setAllowStudentAssignmentResourceTypeFilter = (allowStudentAssignmentResourceTypeFilter) => {
    this.allowStudentAssignmentResourceTypeFilter = allowStudentAssignmentResourceTypeFilter;
  }

  @action clearAll = () => {
    this.alwaysExcludeStudentAssignmentCardAlignmentPills = true;
    this.currentStudentAssignmentMenuStatus = null;
    this.loadingStudentAssignmentMenu = false;
    this.studentAssignmentMenuStatusOrderArray = [
      ASSIGNMENT_MENU_STATUS.CURRENT,
      // ASSIGNMENT_MENU_STATUS.TODAY,
      ASSIGNMENT_MENU_STATUS.CLOSED,
      ASSIGNMENT_MENU_STATUS.GRADED
    ];
    this.allowStudentAssignmentResourceTypeFilter = false;
  }
}

export default new StudentAssignmentManager();
